import React from 'react';
import { Box, Typography } from '@mui/material';

export default function OrdersPage() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Pedidos
      </Typography>
      <Typography color="textSecondary">
        Página de pedidos em construção
      </Typography>
    </Box>
  );
}